import { cn } from '../../lib/cn';
import type { FeeRow } from '../../financialintel/framework';

type Props = { fees?: FeeRow[] };

export function FeeIntelligencePanel({ fees = [] }: Props) {
  return (
    <div className="space-y-2">
      {fees.map((f) => (
        <div
          key={f.type}
          className={cn(
            'flex items-center justify-between gap-3 rounded-lg border p-3',
            f.leak ? 'border-warning-200 bg-warning-50 dark:border-warning-900 dark:bg-warning-950' : 'border-slate-200 dark:border-slate-700',
          )}
        >
          <div>
            <p className="text-sm font-medium">{f.type}</p>
            <p className="text-xs text-slate-500">{f.pct} of revenue</p>
          </div>
          <div className="text-right">
            <p className="font-semibold">{f.amount}</p>
            {f.leak && <p className="text-xs text-warning-600">Fee leakage detected</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
